// extracted by mini-css-extract-plugin
export default {"root":"TypeSwitcher_root__t-HVL","placeHolderShimmer":"TypeSwitcher_placeHolderShimmer__-8Rk+"};